var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "successMsgModal", "data-backdrop": "static" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("img", {
              staticClass: "close-icon",
              attrs: {
                src: "/static/images/icons/close_icon.svg",
                alt: "close-icon",
              },
              on: { click: _vm.redirectToLogin },
            }),
            _vm._m(0),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-12 ok-btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-green-button",
                    on: {
                      click: function ($event) {
                        return _vm.redirectToLogin()
                      },
                    },
                  },
                  [_vm._v(" OK ")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card text-center" }, [
      _c("img", {
        staticClass: "success_logo",
        attrs: {
          src: require("../../../public/static/images/icons/checkbox.svg"),
          alt: "checkbox-icon",
        },
      }),
      _c("div", { staticClass: "card-title" }, [
        _c("p", { staticClass: "verification-text" }, [
          _vm._v(" A verification link has been sent to your email account "),
        ]),
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12 card-text" }, [
          _c("p", { staticClass: "success-message" }, [
            _vm._v(
              " Please check your email for a verification link in order to access your newly created account or click on "
            ),
            _c(
              "a",
              { staticClass: "link", attrs: { href: "/verificationlink" } },
              [_vm._v("request new link")]
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }